import { Box, useTheme } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Outlet, useParams } from "react-router";
import NavButton from "../components/Navigation/NavButton";
import { logoutWithCleanup } from "../env";
import { useAuth } from "../hooks/useAuth";

interface Props {
  children?: React.ReactNode;
}

const AuthLayout: React.FC<Props> = () => {
  const [t, i18n] = useTranslation();
  const { client: selectedClient } = useParams<{ client: string }>();
  const theme = useTheme();
  const { logout } = useAuth();

  const appName = i18n.exists(`defaultLayout.appNames.${selectedClient}`)
    ? t(`defaultLayout.appNames.${selectedClient}`)
    : t("defaultLayout.appName", { product: selectedClient?.split("_")?.join(" ") });

  return (
    <Box
      sx={{
        background: `conic-gradient(from -50deg at 50% 50%, ${theme.palette.secondary.main} 0deg, ${theme.palette.secondary.dark} 180deg, ${theme.palette.secondary.main} 360deg)`,
        overflowY: "scroll",
      }}
    >
      <Helmet>
        <title>{appName}</title>
        <meta name="description" content={appName} />
      </Helmet>
      <div className="absolute top-0 right-0 pt-8 pr-8 pb-3 pl-3">
        <NavButton className="border-white pb-3 pl-3" onClick={() => logoutWithCleanup(logout)}>
          {t("common.logout")}
        </NavButton>
      </div>
      <div className="h-screen w-full flex justify-center sm:items-center">
        <Outlet />
      </div>
    </Box>
  );
};

export default AuthLayout;
